import React, { useState } from 'react';
import { WorkflowInputLayout } from './WorkflowInputLayout';
import HumanTab from '../../../components/utility_planning/scenarioInputs/HumanTab';

const defaultHuman = {
  demographicsDatasetId: null,
  travelSurveyId: null,
};

export default function DemographicsInputPage() {
  const [data, setData] = useState(defaultHuman);
  const updateData = (next) => setData((prev) => ({ ...prev, ...next }));

  return (
    <WorkflowInputLayout title="Demographics">
      <div className="bg-white rounded-xl shadow-lg font-ui">
        <HumanTab
          data={data}
          updateData={updateData}
          utilityName="Central Hudson"
          region="NY"
          section="demographics"
        />
      </div>
    </WorkflowInputLayout>
  );
}
